export interface StudentForSave {
    name: string;
}

export function mapStudentsForSave(students: Array<string>): Array<StudentForSave> {
    return students
        .map((student) => ({ name: student.replace(/\s{2,}/g, ' ').trim() }))
        .filter(({ name }) => name && name !== '');
}
